export default __webpack_public_path__ + "static/media/Fact_Sheet.9dcbb881.pdf";